import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BranchResponse } from '../models/branch.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BranchService {
  private apiUrl = `${environment.apiUrl}/branch`;

  constructor(private http: HttpClient) {}

  getBranches(): Observable<BranchResponse> {
    return this.http.get<BranchResponse>(this.apiUrl);
  }
}
